var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Search.less');

var SubSectionDummy = require('front/pages/Section/SubSectionDummy');

var SearchList = require('front/components/SearchComponents/SearchList');
var SearchListTemplate = require('front/components/SearchComponents/SearchList.jinja');

var CommonSearchInput = require('front/components/CommonSearchInput/CommonSearchInput');


var objectFitImages = require('object-fit-images');

module.exports = Section.extend({

    el: '.Search',

    events: {
        'click .Search-categoryLogin span': 'onLoginClick',
        'change input[type="radio"]': 'onRadioChange'
    },


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSearchInput': {selector: '.CommonSearchInput', viewConstructor: CommonSearchInput}
    },


    API_URL: Urls['front:api:search']('json') + '?q=',
    RESULTS_PER_PAGE: 10,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onInputEnterPressed');

        Section.prototype.initialize.call(this, options);

        this.$('.SearchList').data('instance', new SearchList({
            el: this.$('.SearchList')[0]
        }));
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    onLoginClick: function (e) {
        e.preventDefault();
        e.stopPropagation();

        window.location.href = $(e.currentTarget).attr('data-href');
    },


    viewsRegistration: function () {
        Section.prototype.viewsRegistration.call(this);

        this.searchInput = this.getView('CommonSearchInput');

        this.searchInput.on('enter-pressed', this.onInputEnterPressed);
    },


    deactivate: function (params) {

        this.searchInput.off('enter-pressed', this.onInputEnterPressed);

        return Section.prototype.deactivate.call(this, params);
    },


    onInputEnterPressed: function (query) {
        this.$('.CommonSearchInput input').blur();

        Backbone.history.navigate(app.composeSearchUrl(query, 1, this.category), {trigger: 'true'});
    },


    //updates search query in header input
    updateQueryInputString: function () {
        this.$('.CommonSearchInput input').val(decodeURIComponent(this.query));
    },


    //updates categories links for current query and set active category
    updateCategoriesSelector: function () {

        this.$('.Search-category').each(function (ind, item) {
            var $item = $(item);
            var category = $item.attr('data-value');

            //set actual url for each category for current search query and page
            $item
                .toggleClass('Search-category--active', category == this.category)
                .attr('href', app.composeSearchUrl(this.query, 1, category))
                .find('.Search-categoryCaptionValue')
                    .text(this.stats[category]);
        }.bind(this));
    },


    //updates current page on pages selector (and total pages or hides all pagination at all)
    updatePagesSelector: function () {
        var pages = Math.ceil(this.filteredResults.length / this.RESULTS_PER_PAGE);

        var $pagination = this.$('.Search-paginationWrapper');
        var $pageItems = $pagination.find('li');

        //if list of pages changed, simply create new
        if ($pageItems.length != pages) {
            $pageItems.remove();

            for (var i = 1; i <= pages; i++) {
                $pagination
                    .find('ul')
                    .append('<li data-page="' + i + '"><a class="u-Route">' + i + '</a></li>');
            }

            $pageItems = $pagination.find('li');
        }

        _.each($pageItems, function (item) {
            var $item = $(item);
            var page = $item.attr('data-page');

            $item
                .toggleClass('Search-paginationListItem--active', page == this.page)
                .find('a')
                .attr('href', app.composeSearchUrl(this.query, page, this.category));
        }.bind(this));

        $pagination.toggle(pages > 1);

        this.$('.Search-nextPage')
            .toggle(this.page < pages)
            .attr('href', app.composeSearchUrl(this.query, this.page + 1, this.category));
    },


    //renders results page for this.results, this.page, this.category
    //and hides previous one
    renderCurrentResultsPage: function () {
        var $currentList = this.$('.SearchList');

        var renderedTemplate = SearchListTemplate.render({
            'data': {
                'content': this.pageResults
            }
        });
        $searchList = $(renderedTemplate);
        $searchList.addClass('SearchList--hidden');
        this.$('.Search-results').append($searchList);

        $searchList.data('instance', new SearchList({
            el: $searchList[0]
        }));

        $searchList.outerHeight();

        $searchList.removeClass('SearchList--hidden');
        $currentList.addClass('SearchList--hidden');

        //set links classes: outer, tel, email, file, inner
        //its important for inner routing and for links styling
        //work both for popups and pages
        app.utils.updateLinksAttributes($searchList);

        objectFitImages();

        app.animateWindowScroll(app.settings.isPhone ? 120 : 0);

        clearTimeout(this.destroyPrevListTimeout);

        this.destroyPrevListTimeout = setTimeout(function () {
            _.each($currentList, function (item) {
                var $item = $(item);
                $item.data('instance').destroy();
            });
        }, 1000);
    },


    filterResults: function () {
        //filter by category
        var filteredResults = _.filter(this.results, function (result) {
            if (this.category === 'all' || result.category === 'myadg') {
                return true;
            }
        }.bind(this));

        this.filteredResults = filteredResults;

        //filter by page
        this.pageResults = filteredResults.slice((this.page - 1) * this.RESULTS_PER_PAGE, this.page * this.RESULTS_PER_PAGE);
    },


    //on update without reload
    update: function (view, params) {
        _.extend(this, params.viewData); //query, page, category

        // console.log('update', params.viewData);

        //check:
        //1. view == SubSectionDummy change search params without reload, otherwise user clicks on some search results with popup url (both cases invokes update on search page, but we only interested in first one)
        //2. compage search hashes, actual for closing popup from search results to prevent api request and result reload/rerender
        if (view == SubSectionDummy && this.getSearchHash(params.viewData) != this.lastSearchHash) {
            this._xhr && this._xhr.abort();

            this.lastSearchHash = this.getSearchHash(params.viewData);

            if (app.data.searchResults[this.query]) {
                //if already have in cache use it
                this.results = app.data.searchResults[this.query].results;
                this.stats = app.data.searchResults[this.query].stats;

                this.filterResults();
                this.renderCurrentResultsPage();
                this.updateQueryInputString();
                this.updateCategoriesSelector();
                this.updatePagesSelector();
            } else {
                //else request api for search results
                this._xhr = $.ajax({
                    'url': this.API_URL + encodeURIComponent(this.query),
                    'method': 'GET',
                    'success': function (data) {
                        this.results = data.results;
                        this.stats = data.stats;

                        app.data.searchResults = app.data.searchResults || {};
                        app.data.searchResults[this.query] = {
                            results: this.results,
                            stats: this.stats
                        };

                        this.filterResults();
                        this.renderCurrentResultsPage();
                        this.updateQueryInputString();
                        this.updateCategoriesSelector();
                        this.updatePagesSelector();
                    }.bind(this),
                    'error': function () {
                        alert('Something went wrong, try again later.');
                    }.bind(this),
                    'context': this
                });
            }
        }

        return Section.prototype.update.call(this, view, params);
    },


    //on open from server by direct url
    activate: function (params) {

        //activate can fire on search from another page, router handles it (in 'route' function) and reloads to search page (no SPA), but erro with acessing to app.data.searchResults[this.query].results appear for some milliseconds
        if (!params || params.server) {

            _.extend(this, this.options.viewData); //query, page, category

            this.lastSearchHash = this.getSearchHash(this.options.viewData);

            this.results = app.data.searchResults[this.query].results;
            this.stats = app.data.searchResults[this.query].stats;
            this.filterResults();
            this.updateQueryInputString();
            this.updateCategoriesSelector();
            this.updatePagesSelector();
        }

        return Section.prototype.activate.call(this, params);
    },


    getSearchHash: function (params) {
        return params.query + ',' + params.page + ',' + params.category;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Search/Search.js
// module id = 293
// module chunks = 0